import Joi from "joi"
import { FieldType, TextFieldType } from "../../components/fields"
import { FormComponent } from "../../components/form"
import { HeroBanner,Row,Col, BoxContainer,Text } from "../../style/base.style"
import { useDeviceType } from "../../contexts/DeviceContext"
import { useContactType } from "../../contexts/ContactContext"
import { DateTimePickerType } from "../../components/fields/DatePicker"
import { useDictionary } from "../../contexts/dictionary"
import { ActionButton, ButtonStyle } from "../../components/buttons/ActionButton"
import { useEffect, useState } from "react"
import { useFormHandling } from "../../hooks/formUtils"
import { RequestConfigs } from "../../api"
import { useNavigate } from "react-router-dom"
import { CheckoutLayout } from "../../components/checkout/CheckoutLayout"
import { routesMap } from "../../constants/routes"

export const AddtionalInfo = () => {
    const {isMobile} = useDeviceType()
    const {contact} = useContactType()
    const {translate} = useDictionary()
    const navigate = useNavigate()
    const {handleClick,handleInputChange,serverRes} = useFormHandling({requestType:RequestConfigs.updateContact})

    useEffect(() => {
        if(serverRes?.succeeded){
            navigate(routesMap.checkoutFamily.to)
        }

    },[serverRes])

    const fields:FieldConfig[] = [
        {
            name:"First_Name",
            label:"First Name",
            type:FieldType.text,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.First_Name,
            typeOptions:{
                type:TextFieldType.text
            }
        },
        {
            name:"Last_Name",
            label:"Last Name",
            type:FieldType.text,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.Last_Name,
            typeOptions:{
                type:TextFieldType.text
            }
        },
        {
            name:"payments0__Gov_Id",
            label:"Id",
            type:FieldType.text,
            joiSchema:Joi.string().length(9).required(),
            defaultValue:contact?.payments0__Gov_Id,
            typeOptions:{
                type:TextFieldType.text,
                maxLength:9,
            }
        },
        {
            name:"Date_of_Birth",
            label:"Date Of Birth",
            type:FieldType.dateTime,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.Date_of_Birth,
            typeOptions:{
                dateType:DateTimePickerType.date
            }
        },
        {
            name:"Salutation",
            label:"Salutation",
            type:FieldType.select,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.Salutation,
            typeOptions:{
                options:[
                    {label:"Mr.",value:"Mr."},
                    {label:"Mrs.",value:"Mrs."},
                    {label:"Miss.",value:"Miss."},
                    {label:"Master.",value:"Master."},
                    
                ]
            }
        },
        {
            name:"Email",
            label:"Email",
            type:FieldType.text,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.Email,
            typeOptions:{
                type:TextFieldType.text
            }
        },
        {
            name:"Phone",
            label:"Phone",
            type:FieldType.text,
            joiSchema:Joi.string().required(),
            defaultValue:contact?.Phone,
            typeOptions:{
                type:TextFieldType.text
            }
        },
    ]


  

    return (
        <CheckoutLayout page="update_your_info">

        <Row $width="100%" $justifyContent="center" $alignItems="center">
                <Col $width="100%" $alignItems="center" $gap={20} >
                    <BoxContainer>
                        <Text>
                            {translate("additional_info_desc")}
                        </Text>
                    </BoxContainer>

                    <BoxContainer>
                        <Col $width={isMobile?"100%":"100%"} $alignItems={isMobile?"center":"flex-start"} >
                    <FormComponent
                        fields={fields}
                        onChange={handleInputChange}
                        serverRes={serverRes}
                        />
                        </Col>
                    </BoxContainer>
                 

                 

                  <Row $width="100%" $justifyContent="flex-end" $alignItems="center">
                    <ActionButton
                            label={translate("continue")}
                            onClick={handleClick}
                        />
                    
                  </Row>
                
                </Col>
            
               


               </Row>
        
        </CheckoutLayout>
       
            
      
    )
}


